import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { type Enum } from '@webapp/infrastructure/types/Enum'
import messages from './messages'

export const MainCustomFieldSetupPageTabs = {
  LINE_ITEMS: 'line-item-fields',
  HEADER_FIELDS: 'header-fields',
} as const

export type MainCustomFieldSetupPageTab = Enum<
  typeof MainCustomFieldSetupPageTabs
>

export interface MainCustomFieldSetupPageParams {
  tab?: MainCustomFieldSetupPageTab
}

const MainCustomFieldSetupViewChunk = lazy(() =>
  import('../containers/MainCustomFieldSetupView').then(
    ({ MainCustomFieldSetupView }) => ({
      default: MainCustomFieldSetupView,
    })
  )
)

export const MainCustomFieldSetupPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.mainCustomFieldSetupPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsPageTitle),
        },
        {
          name: intl.formatMessage(messages.mainCustomFieldSetupPageTitle),
        },
      ]}
    >
      <MainCustomFieldSetupViewChunk />
    </Page>
  )
}
